/* eslint-disable no-loss-of-precision */
import HalfCircleUp from '../Nose/HalfCircleUp'
import Flat from '../Nose/Flat'
import TriangleDown from '../Nose/TriangleDown'
import Round from '../Nose/Round'
import Normal from '../Nose/Normal'
import HalfCircleDown from '../Nose/HalfCircleDown'
import TriangleUp from '../Nose/TriangleUp'
import Rounded from '../Nose/Rounded'
import Oval from '../Nose/Oval'

const data = [
  {
    id: 'TriangleUp',
    svg: TriangleUp,
    positioning: {
      pointNarrow: {
        y: 93.12626647949219,
        scaleX: 1,
      },
      pointMedium: {
        y: 92.08815002441406,
        scaleX: 1,
      },
      pointWide: {
        y: 90.19976806640625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 93.21882629394531,
        scaleX: 1,
      },
      roundMedium: {
        y: 94.40556335449219,
        scaleX: 1,
      },
      roundWide: {
        y: 93.73493957519531,
        scaleX: 1,
      },
      squareNarrow: {
        y: 92.56263732910156,
        scaleX: 1,
      },
      squareMedium: {
        y: 92.21946716308594,
        scaleX: 1,
      },
      squareWide: {
        y: 93.33113098144531,
        scaleX: 1,
      },
    },
  },
  {
    id: 'HalfCircleUp',
    svg: HalfCircleUp,
    positioning: {
      pointNarrow: {
        y: 115.78225708007812,
        scaleX: 1,
      },
      pointMedium: {
        y: 116.08319091796875,
        scaleX: 1,
      },
      pointWide: {
        y: 113.16276550292969,
        scaleX: 1,
      },
      roundNarrow: {
        y: 116.89309692382812,
        scaleX: 1,
      },
      roundMedium: {
        y: 117.45652770996094,
        scaleX: 1,
      },
      roundWide: {
        y: 116.56584167480469,
        scaleX: 1,
      },
      squareNarrow: {
        y: 114.44877624511719,
        scaleX: 1,
      },
      squareMedium: {
        y: 114.66592407226562,
        scaleX: 1,
      },
      squareWide: {
        y: 115.03916931152344,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Flat',
    svg: Flat,
    positioning: {
      pointNarrow: {
        y: 90.45413208007812,
        scaleX: 1,
      },
      pointMedium: {
        y: 91.00823974609375,
        scaleX: 1,
      },
      pointWide: {
        y: 86.00025939941406,
        scaleX: 1,
      },
      roundNarrow: {
        y: 92.94960021972656,
        scaleX: 1,
      },
      roundMedium: {
        y: 91.59379577636719,
        scaleX: 1,
      },
      roundWide: {
        y: 90.5411376953125,
        scaleX: 1,
      },
      squareNarrow: {
        y: 90.27009582519531,
        scaleX: 1,
      },
      squareMedium: {
        y: 90.34490966796875,
        scaleX: 1,
      },
      squareWide: {
        y: 89.09956359863281,
        scaleX: 1,
      },
    },
  },
  {
    id: 'TriangleDown',
    svg: TriangleDown,
    positioning: {
      pointNarrow: {
        y: 104.28977966308594,
        scaleX: 1,
      },
      pointMedium: {
        y: 105.55471801757812,
        scaleX: 1,
      },
      pointWide: {
        y: 104.82879638671875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 105.73143005371094,
        scaleX: 1,
      },
      roundMedium: {
        y: 106.21551513671875,
        scaleX: 1,
      },
      roundWide: {
        y: 104.05679321289062,
        scaleX: 1,
      },
      squareNarrow: {
        y: 103.11978149414062,
        scaleX: 1,
      },
      squareMedium: {
        y: 103.665771484375,
        scaleX: 1,
      },
      squareWide: {
        y: 104.44032287597656,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Round',
    svg: Round,
    positioning: {
      pointNarrow: {
        y: 94.48646545410156,
        scaleX: 1,
      },
      pointMedium: {
        y: 95,
        scaleX: 1,
      },
      pointWide: {
        y: 93.17138671875,
        scaleX: 1,
      },
      roundNarrow: {
        y: 96.51911926269531,
        scaleX: 1,
      },
      roundMedium: {
        y: 96.27308654785156,
        scaleX: 1,
      },
      roundWide: {
        y: 95,
        scaleX: 1,
      },
      squareNarrow: {
        y: 95.23992919921875,
        scaleX: 1,
      },
      squareMedium: {
        y: 95,
        scaleX: 1,
      },
      squareWide: {
        y: 95,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Normal',
    svg: Normal,
    positioning: {
      pointNarrow: {
        y: 100.07505798339844,
        scaleX: 1,
      },
      pointMedium: {
        y: 102.46168518066406,
        scaleX: 1,
      },
      pointWide: {
        y: 100.02867889404297,
        scaleX: 1,
      },
      roundNarrow: {
        y: 101.29359436035156,
        scaleX: 1,
      },
      roundMedium: {
        y: 101.82440185546875,
        scaleX: 1,
      },
      roundWide: {
        y: 100.44261169433594,
        scaleX: 1,
      },
      squareNarrow: {
        y: 101.32601928710938,
        scaleX: 1,
      },
      squareMedium: {
        y: 100.42704772949219,
        scaleX: 1,
      },
      squareWide: {
        y: 99.99668884277344,
        scaleX: 1,
      },
    },
  },
  {
    id: 'HalfCircleDown',
    svg: HalfCircleDown,
    positioning: {
      pointNarrow: {
        y: 118.63169860839844,
        scaleX: 1,
      },
      pointMedium: {
        y: 118.33543395996094,
        scaleX: 1,
      },
      pointWide: {
        y: 115.89508819580078,
        scaleX: 1,
      },
      roundNarrow: {
        y: 119.3424072265625,
        scaleX: 1,
      },
      roundMedium: {
        y: 119.09259033203125,
        scaleX: 1,
      },
      roundWide: {
        y: 117.26170349121094,
        scaleX: 1,
      },
      squareNarrow: {
        y: 116.98776245117188,
        scaleX: 1,
      },
      squareMedium: {
        y: 116.10943603515625,
        scaleX: 1,
      },
      squareWide: {
        y: 116.93896484375,
        scaleX: 1,
      },
    },
  },

  {
    id: 'Rounded',
    svg: Rounded,
    positioning: {
      pointNarrow: {
        y: 96.75750732421875,
        scaleX: 1,
      },
      pointMedium: {
        y: 96.88560485839844,
        scaleX: 1,
      },
      pointWide: {
        y: 95.22857666015625,
        scaleX: 1,
      },
      roundNarrow: {
        y: 97.50233459472656,
        scaleX: 1,
      },
      roundMedium: {
        y: 96.51383972167969,
        scaleX: 1,
      },
      roundWide: {
        y: 96.4586181640625,
        scaleX: 1,
      },
      squareNarrow: {
        y: 95.50355529785156,
        scaleX: 1,
      },
      squareMedium: {
        y: 95.49082946777344,
        scaleX: 1,
      },
      squareWide: {
        y: 95,
        scaleX: 1,
      },
    },
  },
  {
    id: 'Oval',
    svg: Oval,
    positioning: {
      pointNarrow: {
        y: 98.32884216308594,
        scaleX: 1,
      },
      pointMedium: {
        y: 98.53494262695312,
        scaleX: 1,
      },
      pointWide: {
        y: 99.11439514160156,
        scaleX: 1,
      },
      roundNarrow: {
        y: 99.95442199707031,
        scaleX: 1,
      },
      roundMedium: {
        y: 100.56401062011719,
        scaleX: 1,
      },
      roundWide: {
        y: 99.99220275878906,
        scaleX: 1,
      },
      squareNarrow: {
        y: 98.22969055175781,
        scaleX: 1,
      },
      squareMedium: {
        y: 97.24795532226562,
        scaleX: 1,
      },
      squareWide: {
        y: 98.00967407226562,
        scaleX: 1,
      },
    },
  },
]

export default data
